import React, {Component} from "react"
import {getCurrentLocale} from "../../utils/getCurrentLocale";
import {Link} from 'gatsby';

import searchStyles from './search.module.scss'



export default class Search extends Component {
    constructor(props) {
        super(props);
        this.state = {
            query: ``,
            results: [],
            currentLocale: getCurrentLocale(props.location.pathname),
        }
    }

    render() {
        return (
            <div className={searchStyles.searchContainer}>
                <input className={searchStyles.searchInput} type="text" value={this.state.query} onChange={this.search} placeholder={this.state.currentLocale == 'ru' ? 'Поиск' : 'Search'} />
                <ul className={searchStyles.searchResultsList}>
                    {this.state.results.map(page => (
                        <li className={searchStyles.searchResult} key={page.id}>
                            <Link className={searchStyles.searchResultA} to={"/" + page.slug}>{page.title}</Link>
                        </li>
                    ))}
        </ul>
            </div>
        )
    }

    getSearchResults(query) {
        if (!query || !window.__LUNR__) return [];
        const lunrIndex =  window.__LUNR__[this.state.currentLocale];
        const results = lunrIndex.index.search(query);
        return results.map(({ ref }) => lunrIndex.store[ref])
    }

    search = event => {
        const query = event.target.value;
        const results = this.getSearchResults(query);
        this.setState(s => {
            return {
                results,
                query,
            }
        })
    }
}